var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDiamondNoFill = function SvgDiamondNoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.362,
    height: 11
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.729 11h-.1C3.845 7.23.716 5.536 0 5.536v-.073a5 5 0 002.5-1.091A5.676 5.676 0 004.633 0h.1a5.512 5.512 0 002.089 4.311 5.213 5.213 0 002.54 1.152v.073c-.717 0-3.844 1.695-4.633 5.463z",
    fill: "#cecece"
  })));
};

export default SvgDiamondNoFill;